<template>
    <div>
        <div class="modal_header">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24">
                    <div class="grid-content bg-purple">
                        <div class="title_h">
                            {{ $t('message.update_organization') }}
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="24">
                    <div class="grid-content bg-purple-light">
                        <el-row class="button_r">
                           <el-button type="success" :loading="loadingButton" :disabled="loadingButton ? true : false" @click="submit">{{ $t('message.save_and_close') }}</el-button>
                            <el-button @click="resetForm('form')">{{ $t('message.close') }}</el-button>
                        </el-row>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="row">
            <div class="col-12 mt-2">
                <div class="modal-body">
                    <el-tabs type="border-card">
                        <el-tab-pane :label="$t('message.update')">
                            <el-form ref="form" status-icon :model="form" :rules="rules" :label-position="'left'">
                                <el-row :gutter="24">
                                    <el-col :span="8">
                                        <el-form-item :label="columns.company_name.title" prop="company_name">
                                            <el-input v-model="form.company_name" autocomplete="off"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="columns.code.title" prop="code">
                                            <el-input v-model="form.code" autocomplete="off"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="columns.phone.title" prop="phone">
                                            <el-input v-model="form.phone" autocomplete="off"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="columns.fax.title" prop="fax">
                                            <el-input v-model="form.fax" autocomplete="off"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="columns.email.title" prop="email">
                                            <el-input v-model="form.email" autocomplete="off"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="columns.address.title" prop="address">
                                            <el-input v-model="form.address" autocomplete="off"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="columns.inn.title" prop="inn">
                                            <el-input v-model="form.inn" autocomplete="off"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="columns.mfo.title" prop="mfo">
                                            <el-input v-model="form.mfo" autocomplete="off"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="columns.okonx.title" prop="okonx">
                                            <el-input v-model="form.okonx" autocomplete="off"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="columns.oked.title" prop="oked">
                                            <el-input v-model="form.oked" autocomplete="off"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="columns.rkp_nds.title" prop="rkp_nds">
                                            <el-input v-model="form.rkp_nds" autocomplete="off"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('message.patients')" >
                            <el-row :gutter="24">
                                <el-col :span="24">
                                    <patientTable ref="patientTableComponent" :organizationId="form.id"></patientTable>
                                </el-col>
                            </el-row>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('message.aggrement')">
                            <el-row :gutter="24">
                                <el-col :span="24">
                                    <contractTable ref="contractTableComponent" :organizationId="form.id"></contractTable>
                                </el-col>
                            </el-row>
                        </el-tab-pane>
                    </el-tabs>
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters,mapActions} from 'vuex';
    import patientTable from './include/patient-table.vue';
    import contractTable from './include/contract-table.vue';
    import form from '@/utils/mixins/form';
    export default {
        mixins:[form],
        props: {
            reloadModel: {type: Boolean, default: true}
        },
        components: {
            patientTable,
            contractTable,
        },
        data(){
            return {
                input:""
            }
        },
        watch: {
            reloadModel: {
                handler: function () {
                    if (this.reloadModel){
                        this.loadModel()
                    }
                },
                deep: true
            },
        },
        async created(){
            await this.contractList();
        },
        computed: {
            ...mapGetters({
                rules: 'organizations/rules',
                model: 'organizations/model',
                columns: 'organizations/columns',
                pagination: "patients/pagination",
                filter: "patients/filter",
                sort: "patients/sort",
            })
        },
        methods:{
            ...mapActions({
                save: 'organizations/update',
                contracts: 'contracts/index',
            }),
            loadModel(){
                this.form = JSON.parse( JSON.stringify( this.model ));
            },
            refreshpatientData(){
                this.$refs.patientTableComponent.refresh()
                this.$refs.contractTableComponent.refresh()
            },
            refreshcontractData(){
                this.$refs.contractTableComponent.refresh()
            },
            submit(close = true){
                this.$refs['form'].validate((valid) => {
                    if (valid){
                        this.loadingButton = true;
                        this.save(this.form)
                            .then(res => {
                                this.loadingButton = false;
                                this.$notify({
            title: 'Успешно',
            type: "success",
            offset: 130,
            message: res.message
          });
                                this.parent().listChanged()
                                this.resetForm('form');
                            })
                            .catch(err => {
                                this.loadingButton = false;
                                this.$notify({
        title: 'Ошибка',
        type: "error",
        offset: 130,
        message: err.error.message
      });
                                
                            });
                    }
                });
            },
            contractList(){
                // this.contracts()
                // .then(res => {
                // })
                // .catch(err => {
                // });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.$emit('c-close',{drawer: 'drawerUpdate'});
            },
        }
    }

</script>
